import React from 'react';

const ProjectDescription = function(props) {
  return (
    <div>
      <p>
        This high-specification extension creates an open-plan dining and kitchen
        area, which opens directly onto the enclosed garden. The form and proportions
        of the building and the expansive glazing are reflections of the distinct
        geometry of the original Grade II Listed Georgian townhouse, itself built in
        approximately 1820.
      </p>
      <p>
        The sliding glass uses the narrowest framing system available at the time, yet
        achieves a 2.6x2.8m sliding glass unit, with a returning panel which slides
        into a concealed pocket. In summer, the room has a ‘spa quality’ character opening
        onto the garden, and with a large roof light installed at the junction with the
        main house, natural light floods the new kitchen.
      </p>
      <p>
        During cooler months, a concealed curtain track allows heavy, thermally-lined
        curtains to be installed to retain heat. This changes the quality of the spaces
        to become softened and warm. Thermal performances for the floor, walls and roof
        are also significantly enhanced.
      </p>
      <p>
        The scheme was given a Commendation in the Spirit of Ingenuity awards, RIBA
        East.
      </p>
      <p className="ps">
        The project was completed while Matt was with CSA Design Studio in Norfolk.
        Images courtesy of CSA Design Studio
      </p>
    </div>
  );
}

export default ProjectDescription;



// WEBPACK FOOTER //
// ./src/components/projects/crescent-extension.jsx